import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

const COLOR_STYLES = {
  green: { bg: "from-ism-teal/20 to-ism-teal/5", border: "border-ism-teal/30", text: "text-ism-teal", iconBg: "bg-ism-teal/20" },
  blue: { bg: "from-ism-teal/20 to-ism-teal/5", border: "border-ism-teal/30", text: "text-ism-teal", iconBg: "bg-ism-teal/20" },
  purple: { bg: "from-gray-500/20 to-gray-500/5", border: "border-gray-500/30", text: "text-gray-300", iconBg: "bg-gray-500/20" },
};

export const ActionButton = ({ onClick, disabled, processing, icon: Icon, color, title, subtitle, testId }) => {
  const style = COLOR_STYLES[color];
  return (
    <motion.button
      onClick={onClick}
      disabled={disabled}
      whileHover={{ scale: 1.02, y: -2 }}
      whileTap={{ scale: 0.98 }}
      className={`w-full bg-gradient-to-br ${style.bg} border ${style.border} rounded-xl p-5 flex items-center justify-between transition-all disabled:opacity-50 disabled:cursor-not-allowed group`}
      data-testid={testId}
    >
      <div className="flex items-center gap-4">
        <motion.div
          className={`p-3 rounded-xl ${style.iconBg} group-hover:scale-110 transition-transform`}
          animate={processing ? { rotate: 360 } : {}}
          transition={processing ? { duration: 1, repeat: Infinity, ease: "linear" } : {}}
        >
          <Icon className={`h-6 w-6 ${style.text}`} />
        </motion.div>
        <div className="text-left">
          <div className={`${style.text} text-lg`}>{title}</div>
          <div className="text-xs text-gray-500">{subtitle}</div>
        </div>
      </div>
      {processing && <Loader2 className={`h-5 w-5 animate-spin ${style.text}`} />}
    </motion.button>
  );
};
